var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8408_72045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.512578 11.8563C0.512016 13.8728 1.04302 15.8417 2.0527 17.5771L0.416016 23.5066L6.53152 21.9156C8.22298 22.8292 10.1181 23.308 12.044 23.3081H12.0491C18.4067 23.3081 23.582 18.1748 23.5847 11.8653C23.586 8.80792 22.3871 5.93295 20.2089 3.76997C18.0311 1.60718 15.1347 0.415458 12.0486 0.414062C5.6902 0.414062 0.515297 5.54709 0.512672 11.8563",
    fill: "url(#paint0_linear_8408_72045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.100313 11.8527C0.0996563 13.9417 0.649687 15.981 1.69537 17.7786L0 23.9207L6.33478 22.2726C8.08022 23.2168 10.0454 23.7147 12.0451 23.7154H12.0502C18.636 23.7154 23.9972 18.3975 24 11.8621C24.0011 8.69488 22.7591 5.71656 20.5031 3.47609C18.2468 1.23591 15.2468 0.00130233 12.0502 0C5.46337 0 0.102938 5.31721 0.100313 11.8527ZM3.87281 17.469L3.63628 17.0965C2.64197 15.5277 2.11716 13.7149 2.11791 11.8534C2.12006 6.4213 6.57544 2.00186 12.054 2.00186C14.7071 2.00298 17.2005 3.02921 19.0759 4.89116C20.9512 6.7533 21.9831 9.22865 21.9824 11.8614C21.98 17.2935 17.5245 21.7135 12.0502 21.7135H12.0463C10.2638 21.7126 8.51569 21.2376 6.99112 20.34L6.62831 20.1265L2.86913 21.1045L3.87281 17.4689V17.469Z",
    fill: "url(#paint1_linear_8408_72045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06383 6.89771C8.84014 6.4044 8.60473 6.39445 8.39202 6.3858C8.21783 6.37836 8.0187 6.37892 7.81977 6.37892C7.62064 6.37892 7.29711 6.45324 7.02364 6.74952C6.74989 7.04608 5.97852 7.76273 5.97852 9.22031C5.97852 10.678 7.04848 12.0866 7.19764 12.2845C7.34698 12.482 9.26323 15.5689 12.2981 16.7564C14.8204 17.7433 15.3336 17.547 15.881 17.4975C16.4285 17.4482 17.6477 16.7811 17.8964 16.0892C18.1453 15.3975 18.1453 14.8046 18.0707 14.6807C17.996 14.5572 17.7969 14.4831 17.4983 14.335C17.1996 14.1868 15.7317 13.4701 15.458 13.3712C15.1843 13.2724 14.9853 13.2231 14.7861 13.5198C14.587 13.8159 14.0152 14.4831 13.841 14.6807C13.6669 14.8787 13.4926 14.9034 13.1941 14.7552C12.8953 14.6065 11.9337 14.2941 10.7929 13.2849C9.90523 12.4996 9.30598 11.5298 9.1318 11.2331C8.95761 10.937 9.11314 10.7764 9.26286 10.6288C9.39702 10.496 9.56155 10.2828 9.71098 10.1099C9.85986 9.93687 9.90955 9.81343 10.0091 9.61585C10.1088 9.41808 10.0589 9.24506 9.98436 9.09687C9.90955 8.94868 9.32933 7.48347 9.06383 6.89771Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8408_72045",
    x1: 1158.85,
    y1: 2309.67,
    x2: 1158.85,
    y2: 0.414062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8408_72045",
    x1: 1200,
    y1: 2392.07,
    x2: 1200,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8408_72045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.d2399620e94b004cc2d3ee24237508a4.svg";
export { ForwardRef as ReactComponent };